export default theme => ({

  code: {
    background: theme.qborder.background.code,
    padding: '1px 5px',
    marginBottom: theme.spacing.unit / 2
  },

  codeNumber: {
    fontWeight: 500
  }

});




// WEBPACK FOOTER //
// ./src/styles/components/list/NodePrimaryText.js